import React, { useEffect } from 'react'
import './Register_now.css'
import '../../home/eternal_elements/Eternal_Elements.css'
import Common_Title_2 from '../../common/common_components/common_title_2/Common_Title_2'
import Spiritual_Truth_Card from '../../home/eternal_elements/spiritual_truth_card/Spiritual_Truth_Card'
import { useDispatch, useSelector } from 'react-redux'
import { BlogCategory } from '../../../features/admin/common/Slice'
import { IDS } from '../../../utils/IDS'




const Register_now = () => {

    const data = [
        {
            img: "/assets/images/explore/register/yoga.png",
            label: "Yoga Programs",
            link: "/all-meditations",
        },
        {
            img: "/assets/images/explore/register/event.png",
            label: "Events",
            link: "/all-shibir",
        },
        {
            img: "/assets/images/explore/register/event.png",
            label: "Accommondation",
            link: "/guest-house",
        },
        {
            img: "/assets/images/explore/register/event.png",
            label: "Health Solution",
            link: "/spandan",
        },
        {
            img: "/assets/images/explore/register/event.png",
            label: "Explore All Offerings",
            link: "/home",
        },
    ];



    const dispatch = useDispatch();
    const categories = useSelector((state) => state.common.blog_categories);

    useEffect(() => {
        dispatch(BlogCategory());
    }, [dispatch]);


    return (
        <>
            <section className="Eternal_Elements">
                <div className="container">
                    <Common_Title_2
                        // titleText="ETERNAL ELEMENTS"
                        subText="Register Now"
                    />

                    <div className="content_div">
                        <div className="row justify-content-center">
                            <div className="col-xxl-4 col-xl-4 col-md-4 col-sm-6 col-12 mb-3">
                                <Spiritual_Truth_Card
                                    img={data[0]?.img}
                                    label={data[0]?.label}
                                    goto={data[0]?.link}
                                />

                                {/* <Spiritual_Truth_Card
                                    img={IDS.IMG_URL + categories[0]?.Blog_Category?.image}
                                    label={categories[0]?.name}
                                    goto={categories[0]?.blog_category_id}
                                /> */}
                            </div>
                            <div className="col-xxl-8 col-xl-8 col-md-8">
                                <div className="row ">
                                    {data?.slice(1).map((item, index) => (
                                        <div
                                            key={index}
                                            className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6   mb-2 custom_col"
                                        >
                                            <div className="grid_view">
                                                <Spiritual_Truth_Card
                                                    img={item?.img}
                                                    label={item?.label}
                                                    goto={item?.link}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                    {/* {categories?.slice(1).map((item, index) => (
                                        <div
                                            key={index}
                                            className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-6   mb-2 custom_col"
                                        >
                                            <div className="grid_view">
                                                <Spiritual_Truth_Card
                                                    img={IDS.IMG_URL + item?.Blog_Category?.image}
                                                    label={item?.name}
                                                    goto={item?.blog_category_id}
                                                />
                                            </div>
                                        </div>
                                    ))} */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Register_now